import React from "react";
import { useStyle } from "../context/StyleContext";
const ImageTemplate = React.forwardRef(({ photos, filter, theme }, ref) => {
  const name = localStorage.getItem("photobooth_boothName");
  console.log("Booth Name from localStorage:", name);
  const vintageFilter =
    "sepia(0.5) contrast(1.2) brightness(0.9) saturate(0.6) hue-rotate(-20deg)";
  const styles = useStyle();
  return (
    <div
      ref={ref}
      style={{
        width: "100%",
        height: "100%",
        padding: "10px",
        boxSizing: "border-box",
        display: "grid",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "1/2fr 1/2fr 1/2fr auto",
        gap: "10px",
        alignItems: "center",
        justifyItems: "center",
        background: theme === "dark" ? "black" : "white",
        color: theme === "dark" ? "white" : "black",
        pageBreakInside: "avoid",
      }}
    >
      {photos.slice(0, 3).map((photo, index) => (
        <React.Fragment key={index}>
          <div style={{ textAlign: "center" }}>
            <img
              src={photo}
              alt={`Photo ${index + 1}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "0", // No rounded edges
                filter: filter === "vintage" ? vintageFilter : "none",
              }}
            />
          </div>
        </React.Fragment>
      ))}
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          fontWeight: "bold",
          fontSize: "1.2em",
          letterSpacing: "2px",
          padding: "10px 0",
          width: "100%",
          gridColumn: "span 1",
          marginTop: "5px", // Added marginTop for better spacing
        }}
      >
        <img
          src={name === "Kwave" ? "./KWave.png" : `.${styles.restaurantLogo}`}
          style={{
            width: "250px",
            height: "250px",
            margin: "0 10px", // Added margin for spacing between images
          }}
          alt="Logo"
        />
      </div>
    </div>
  );
});

export default ImageTemplate;
